import { Field } from 'redux-form';
import SlideContainer from '../../../InitFormulaire/Slide/SlideContainer';
import { Text } from '@amo/core/components/forms';

const CoefCommercialSlider = ({ source, motifAvenant, coefCommercialInit, postReloadTarif, data, queryTarif }) => {
    // Affichage uniquement si :
    // - source === 'conseiller'
    // - motifAvenant === 7 (Régularisation) OU motifAvenant === 29 (Fidélisation)
    // - coefCommercialInit <= 0 OU coefCommercialInit === null
    const shouldDisplay =
        source === 'conseiller' &&
        [7, 29, '7', '29'].includes(motifAvenant) &&
        (coefCommercialInit <= 0 || coefCommercialInit === null || coefCommercialInit === undefined);

    if (!shouldDisplay) {
        return null;
    }

    const handleRecalcul = () => {
        postReloadTarif({ form: data, query: queryTarif });
    };

    return (
        <div className="bg-white rounded p-4 mt-4 shadow">
            <p className="f-16 fw-bold text-dark mb-3">Majoration du coefficient commercial</p>
            <div className="row align-items-center">
                <div className="col-7">
                    <Field
                        component={SlideContainer}
                        name={'DemandeTarif[Police][CoefCommercial]'}
                        step={1}
                        min={0}
                        max={100}
                        symbole={'%'}
                        maxBackground={'bg-success'}
                        minBackground={'bg-success'}
                        minColor={'text-white'}
                        maxColor={'text-white'}
                    />
                </div>
                <div className="col-2">
                    <Field
                        component={Text}
                        name={'DemandeTarif[Police][CoefCommercial]'}
                        type={'number'}
                        max={100}
                        min={0}
                    />
                </div>
                <div className="col-3 text-end">
                    <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={handleRecalcul}
                    >
                        Recalculer le tarif
                    </button>
                </div>
            </div>
            <p className="text-muted small mt-2 mb-0">
                0% = pas de majoration, 100% = majoration maximale
            </p>
        </div>
    );
};

export default CoefCommercialSlider;
